const Perfil = {
  Administrador: "Administrador",
  Coordenador: "Coordenador",
  Funcionário: "Usuario",
  Usuario:'Usuario'

}

export default Perfil;
